import { useMemo } from "react";
import { RootState } from "@/models";
import { useSelector } from "react-redux";

export const getRosterInfo = (reports: any, userData: any) => {
    const userId = userData?.userId;
    const classroomId = reports?.roster?.ui?.selections?.classroom?.id;
    const schoolId = reports?.roster?.ui?.selections?.school?.id;
    const students = reports?.roster?.data?.student;
    // CURRENTLY assumes each user only has one district a part of
    // I believe this to be okay?
    const districtId = reports?.roster?.data?.district[0]?.id;
    const status = reports?.roster?.status;
  
    return {
      userId,
      classroomId,
      schoolId,
      districtId,
      status,
      students: students
        ? students.filter(({classroom_id}: {classroom_id: string[]}) => classroom_id.find((id) => `${id}` === `${classroomId}`))
        : [],
    };
}

export const useRosterInfo = () => {
  const reports = useSelector((state: RootState) => state.reports);
  const userData = useSelector((state: RootState) => state.userData);
  const rosterInfo = useMemo(() => getRosterInfo(reports, userData), [reports, userData]);
  return {
    ...rosterInfo,
    reports,
    userData,
  };
};

export default useRosterInfo;
